import _ from 'lodash'
import { CancelToken } from 'axios'


import {
  CHANGE_PRIVACY,
  FETCHED_WIDGET,
  FETCHED_WIDGETS,
  FETCHED_WIDGETS_META,
  FETCHING_WIDGET,
  FETCHING_WIDGETS,
  HIDE_WIDGET_FROM_EPORTFOLIO,
  LIKE_WIDGET,
  PUBLICATION_SCOPE_TREENODE,
  SAVE_WIDGET_PRIVACY,
  SAVING_WIDGET_PRIVACY,
  TOGGLE_MODAL_PRIVACY,
  UNLIKE_WIDGET,
} from '_reducers/widgets'
import { MydAPI } from '_services/default'
import store from 'store'

export const PAGE_SIZE = 10


export const defaultIncludes = (includes=[]) => {
  const { auth } = store.getState()
  const defaultIncludes = [
    'treenodes',
    'owner',
  ]

  if (auth.isLogged && auth.user.isCriss) {
    return [
      ...defaultIncludes,
      'associated_evaluation.node.node_object',
      'evaluation_indicator_results',
      ...includes,
    ]
  }

  return [
    ...defaultIncludes,
    ...includes,
  ]
}


export const defaultFields = () => {
  const defaultFields = {
    'fields[widget]': [
      'analytics',
      'created_by',
      'featured_image',
      'global_evaluations',
      'global_evaluation_state',
      'likes',
      'name',
      'owner',
      'permissions',
      'publication_scope',
      'treenodes',
      'type',
    ].join(','),
    'fields[user]': [
      'avatar',
      'eportfolio_url',
      'first_name',
      'last_name',
      'username',
      'url',
    ].join(','),
    'fields[tree_node]': ['id'].join(','),
    'fields[global_evaluation]': [
      'state',
    ].join(','),
  }

  return defaultFields
}


export function widgetModalChangePrivacy(widgetId, publicationScope, treeNodes=[], open=true) {
  return {
    type: TOGGLE_MODAL_PRIVACY,
    open,
    widgetId,
    publicationScope,
    treeNodes,
  }
}

export function widgetChangePrivacy(publicationScope, treeNodes=[]) {
  return {
    type: CHANGE_PRIVACY,
    publicationScope,
    treeNodes,
  }
}

function _widgetSaveChangePrivacy(widgetId, publicationScope, treeNodes=[]) {
  return {
    type: SAVE_WIDGET_PRIVACY,
    widgetId,
    publicationScope,
    treeNodes,
  }
}

function _widgetSavingChangePrivacy() {
  return {
    type: SAVING_WIDGET_PRIVACY,
  }
}

function _likeWidget(widgetId, userId) {
  return {
    type: LIKE_WIDGET,
    widgetId,
    userId,
  }
}

function _unlikeWidget(widgetId, userId) {
  return {
    type: UNLIKE_WIDGET,
    widgetId,
    userId,
  }
}

export function _fetchingWidgets(infinityScroll=false) {
  return {
    type: FETCHING_WIDGETS,
    infinityScroll,
  }
}


function _fetchedWidgets(widgets, infinityScroll=false) {
  return {
    type: FETCHED_WIDGETS,
    infinityScroll,
    widgets,
  }
}

function _fetchingWidget() {
  return {
    type: FETCHING_WIDGET,
  }
}


function _fetchedWidget(widget) {
  return {
    type: FETCHED_WIDGET,
    widget,
  }
}

function _fetchedWidgetsMeta(meta) {
  return {
    type: FETCHED_WIDGETS_META,
    meta,
  }
}

export const deserializeWidgetData = (item, included) => {
  let assocEvaluation = _.get(item, 'relationships.associatedEvaluation.data', false) && _.find(included, {
    id: _.parseInt(item.relationships.associatedEvaluation.data.id),
    type: 'ict_evaluation',
  })
  const node = assocEvaluation && _.find(
    included,
    {
      id: _.parseInt(assocEvaluation.relationships.node.data.id, 10),
      type: 'cas_node',
    }
  )
  const nodeObject = assocEvaluation && _.find(
    included,
    {
      id: _.parseInt(node.relationships.nodeObject.data.id, 10),
      type: 'cas_node_object',
    }
  )
  const associatedEvaluation = assocEvaluation && {
    id: assocEvaluation.id,
    ...assocEvaluation.attributes,
    content: {
      id: nodeObject.id,
      ...nodeObject.attributes,
    }
  }
  const ownerData = item.relationships.owner.data && _.find(included, {
    id: _.parseInt(item.relationships.owner.data.id),
    type: 'user',
  })
  const owner = ownerData && {
    id: ownerData.id,
    ...ownerData.attributes,
  }
  const indicatorsResults = _.map(_.get(item, 'relationships.evaluationIndicatorResults.data', []), descResult => {
    let dr = _.find(included, {
      id: _.parseInt(descResult.id),
      type: descResult.type,
    })
    return {
      id: dr.id,
      ...dr.attributes,
      type: dr.type,
    }
  })

  return {
    id: item.id,
    ...item.attributes,
    likes: _.map(item.relationships.likes.data, like => {
      let likeData = _.find(included, {
        id: _.parseInt(like.id),
        type: 'widget_likes',
      })
      return likeData.attributes.userId
    }),
    treenodes: _.map(item.relationships.treenodes.data, treenodeRes => {
      let treenode = _.find(included, {
        id: _.parseInt(treenodeRes.id),
        type: treenodeRes.type,
      })
      return {
        id: treenode.id,
        ...treenode.attributes,
        type: treenode.type,
      }
    }),
    globalEvaluations: _.map(_.get(item.relationships.globalEvaluations, 'data', []), globalEvaluation => {
      let ge = _.find(included, {
        id: _.parseInt(globalEvaluation.id),
        type: globalEvaluation.type,
      })
      return {
        id: ge.id,
        ...ge.attributes,
        type: ge.type,
      }
    }),
    indicatorsResults,
    owner,
    associatedEvaluation,
  }
}

let fetchWidgetsCancelToken = null

export function fetchStudentsGallery(
  treeNodeId=null,
  filters={},
  page=1,
  infinityScroll=false,
  includes=defaultIncludes().join(','),
) {
  return dispatch => new Promise((resolve, reject) => {

    let params = {
      'page[number]': _.get(filters, 'page', false) || page,
      'page[size]': PAGE_SIZE,
      include: includes,
      evaluation_status: null,
      start_date: null,
      end_date: null,
      search_field: null,
      tree_node_id: treeNodeId,
      publication_scope: null,
      sort: '-modification_date',
      ...filters,
    }

    dispatch(_fetchingWidgets(infinityScroll))

    if (fetchWidgetsCancelToken)
      fetchWidgetsCancelToken()

    let filter = []
    if (filters.type !== null) {
      filter.push({
        op: 'eq',
        name: 'type',
        val: filters.type,
      })
    }

    params = {
      ...params,
      filter: JSON.stringify(filter),
      ...defaultFields(),
    }

    let path = `/widgets/gallery/${treeNodeId}`
    if (
      treeNodeId === null ||
      treeNodeId === 'my-classgroups'
    )
      path = '/widgets/gallery'

    MydAPI.get(
      path,
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchWidgetsCancelToken = c
        }),
        params,
      }
    ).then(
      response => {
        let res = response.data,
            retWidgets = _.map(response.data.data, item => {
              return deserializeWidgetData(item, res.included)
            })

        dispatch(_fetchedWidgets(retWidgets, infinityScroll))
        dispatch(_fetchedWidgetsMeta(
          {
            count: response.data.meta.count,
            countWithoutPrivacy: response.data.meta.countWithoutPrivacy,
            maxPage: _.ceil(response.data.meta.count / PAGE_SIZE),
            currentPage: page,
          }
        ))
        resolve(retWidgets)

      }
    ).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}

export function fetchWidgetsToAssociate(page=1, filters={}, infinityScroll=false) {
  return dispatch => new Promise((resolve, reject) => {

    if (fetchWidgetsCancelToken)
      fetchWidgetsCancelToken()

    MydAPI.get(
      '/widgets',
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchWidgetsCancelToken = c
        }),
        params: {
          sort: '-modification_date',
          ...filters,
          include: defaultIncludes().join(','),
          'page[number]': page,
          ...defaultFields(),
        }
      }
    ).then(response => {
      let res = response.data,
          retWidgets = _.map(response.data.data, item => {
            return deserializeWidgetData(item, res.included)
          })

      dispatch(_fetchedWidgets(retWidgets, infinityScroll))
      dispatch(_fetchedWidgetsMeta(
        {
          count: response.data.meta.count,
          countWithoutPrivacy: response.data.meta.countWithoutPrivacy,
          maxPage: _.ceil(response.data.meta.count / PAGE_SIZE),
          currentPage: page,
        }
      ))
      resolve(retWidgets)

    }).catch(reject)
  })
}

export function fetchWidgetsByUserId(
  userId,
  page=1,
  _filters={},
  infinityScroll=false,
  includes=defaultIncludes().join(',')
) {
  return dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingWidgets(infinityScroll))

    if (fetchWidgetsCancelToken)
      fetchWidgetsCancelToken()

    const { forms: {filterEportfolio} } = store.getState()
    const {
      mydCompetencesIds,
      evaluationStatus,
      startDate,
      endDate,
      search,
      order,
      orderBy,
      type,
      publicationScope,
    } = filterEportfolio

    const filters = {
      evaluation_status: evaluationStatus,
      start_date: ! _.isNull(startDate) ? startDate.format('YYYY-MM-DD') : null,
      end_date: ! _.isNull(endDate) ? endDate.format('YYYY-MM-DD') : null,
      search_field: search,
      publication_scope: publicationScope,
      myd_competences_ids: mydCompetencesIds,
      sort: order === 'asc' ? `${orderBy}` : `-${orderBy}`,
      type,
      ..._filters,
    }

    let jsonapifilters = []

    if (filters.type !== null) {
      jsonapifilters.push({
        op: 'eq',
        name: 'type',
        val: filters.type,
      })
    }

    MydAPI.get(
      `/users/${userId}/widgets/gallery`,
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchWidgetsCancelToken = c
        }),
        params: {
          'page[number]': _.get(filters, 'page', false) || page,
          'page[size]': PAGE_SIZE,
          end_date: null,
          evaluation_status: null,
          include: includes,
          publication_scope: null,
          search_field: null,
          sort: '-modification_date',
          start_date: null,
          ...filters,
          filter: JSON.stringify(jsonapifilters),
          ...defaultFields(),
        }
      }
    ).then(response => {
      let res = response.data,
          retWidgets = _.map(response.data.data, item => {
            return deserializeWidgetData(item, res.included)
          })

      dispatch(_fetchedWidgets(retWidgets, infinityScroll))
      dispatch(_fetchedWidgetsMeta(
        {
          count: response.data.meta.count,
          countWithoutPrivacy: response.data.meta.countWithoutPrivacy,
          maxPage: _.ceil(response.data.meta.count / PAGE_SIZE),
          currentPage: page,
        }
      ))
      resolve(retWidgets)

    }).catch(reject)
  })
}

export function fetchWidget(widgetId, includes=defaultIncludes().join(',')) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingWidget())
    MydAPI.get(
      `/widgets/${widgetId}?`,
      {
        params: {
          include: includes,
          ...defaultFields(),
        }
      }
    ).then(response => {
      const ret = deserializeWidgetData(response.data.data, response.data.included)
      dispatch(_fetchedWidget(ret))
      resolve(ret)
    }).catch(reject)
  })
}


export function createWidget(data) {
  return new Promise((resolve, reject) => {
    MydAPI.post(`/widgets?include=${defaultIncludes().join(',')}`, data).then(
      response => {
        let retWidget = deserializeWidgetData(response.data.data, response.data.included)
        resolve(retWidget)
      }
    ).catch(reject)
  })
}

export function changePublicationScopeWidget(widgetId, publicationScope, treeNodes=[]) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_widgetSavingChangePrivacy(widgetId, publicationScope, treeNodes))

    let data = {
      id: widgetId,
      type: 'widget',
      attributes: {
        publication_scope: publicationScope,
      }
    }

    if (
      publicationScope === PUBLICATION_SCOPE_TREENODE &&
      ! _.isEmpty(treeNodes)
    ) {
      data = {
        ...data,
        relationships: {
          treenodes: {
            data: _.map(
              treeNodes,
              treeNode => ({
                id: treeNode,
                type: 'tree_node',
              })
            )
          }
        }
      }
    }

    MydAPI.patch(`/widgets/${widgetId}/privacy?include=${defaultIncludes().join(',')}`, {data}).then(
      response => {
        dispatch(_widgetSaveChangePrivacy(widgetId, publicationScope, treeNodes))
        let retWidget = deserializeWidgetData(response.data.data, response.data.included)
        resolve(retWidget)
      }
    ).catch(reject)
  })
}

export const hideFromEportfolio = widgetId => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch({
      type: HIDE_WIDGET_FROM_EPORTFOLIO,
      widgetId,
    })
    MydAPI.delete(`/widgets/${widgetId}/eportfolio`).then(resolve).catch(reject)
  })
}

export function likeWidget(widgetId, userId) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_likeWidget(widgetId, userId))
    MydAPI.post(`/widgets/${widgetId}/likes`).then(resolve).catch(err => {
      dispatch(_unlikeWidget(widgetId, userId))
      reject(err)
    })
  })
}

export function unlikeWidget(widgetId, userId) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_unlikeWidget(widgetId, userId))
    MydAPI.delete(`/widgets/${widgetId}/likes`).then(resolve).catch(err => {
      dispatch(_likeWidget(widgetId, userId))
      reject(err)
    })
  })
}
